import { dark } from "@clerk/themes";

export const clerkAppearance = {
  theme: dark,
  layout: {
    socialButtonsPlacement: "bottom" as const,
    socialButtonsVariant: "blockButton" as const,
  },
  variables: {
    colorBackground: "#0a0a0a",
    colorInputBackground: "#1a1a1a",
    colorInputText: "#a3a3a3",
    colorText: "#e5e5e5",
    colorTextSecondary: "#a3a3a3",
    colorPrimary: "#f59e0b",
    colorDanger: "#ef4444",
    colorSuccess: "#10b981",
  },
  elements: {
    rootBox: "mx-auto",
    card: "bg-background-card border border-border-subtle shadow-layer",
    headerTitle: "text-foreground",
    headerSubtitle: "text-foreground-muted",
    socialButtonsBlockButton: "border-border-subtle bg-background-raised text-foreground hover:bg-background-elevated",
    formButtonPrimary: "bg-brand hover:bg-brand-hover text-black font-semibold",
    formFieldInput: "bg-background border-border-subtle text-[#a3a3a3] placeholder:text-[#6b7280] focus:border-brand",
    formFieldLabel: "text-foreground-muted",
    identityPreviewText: "text-foreground",
    footer: "bg-[#0a0a0a] border-t-0",
    footerAction: "bg-[#0a0a0a]",
    footerActionText: "text-foreground-muted",
    footerActionLink: "text-brand hover:text-brand-hover",
    footerPages: "bg-[#0a0a0a]",
    footerPagesLink: "text-foreground-muted hover:text-foreground",
    logoBox: "opacity-60 brightness-75",
    badge: "text-brand bg-brand/10",
  },
  userProfile: {
    elements: {
      profileSection__emailAddresses: "hidden",
      profileSectionContent__emailAddresses: "hidden",
    },
  },
};
